'use strict';

var _ = require('lodash');
var LiveDataService = function LiveDataService($timeout, $rootScope, flightLiveDataService, marketLiveDataService, scenarioService, hepService) {
  var DEFAULT_INTERVAL = 5;
  var gridIdToMode = {
    'cabin-flight-analysis': 'flight',
    'class-flight-analysis': 'flight',
    'segment-flight-analysis': 'flight',
    'service-flight-analysis': 'flight',
    'market-demand-analysis': 'market',
    'market-product-group-analysis': 'market',
    'service-demand-analysis': 'market'
  };
  var modeToService = {
    'flight': flightLiveDataService,
    'market': marketLiveDataService
  };
  var subscribed = {};
  function getInterval() {
    return (hepService.getSimpleHepProperty('LIVE_DATA_REQUEST_FREQUENCY_MINUTES') || DEFAULT_INTERVAL) * 60 * 1000;
  }
  function isModeSubscribed(mode) {
    return !_.isUndefined(subscribed[mode]);
  }
  function call(mode) {
    var service = modeToService[mode];
    if (service) {
      service.callForNotification(subscribed[mode]).then(function (notification) {
        if (notification && subscribed[mode]) {
          subscribed[mode].notification = notification;
          $rootScope.$broadcast('grid-toolbar:liveDataNotificationsChanged');
        }
      });
    }
  }
  function callForNotification(mode, firstTime) {
    if (!isModeSubscribed(mode)) {
      return;
    }
    var interval = getInterval();

    //NOT calling for data updates immediately when grid just have been loaded and subscribed
    if (!firstTime) {
      call(mode);
    }
    $timeout(function () {
      callForNotification(mode);
    }, interval);
  }
  function isOriginalView() {
    return _.isNil(scenarioService.getSelectedScenario());
  }
  function subscribe(gridId, data) {
    if (!isOriginalView()) {
      return;
    }
    var mode = gridIdToMode[gridId];
    if (isModeSubscribed(mode)) {
      subscribed[mode].loadedData[gridId] = data;
      if (subscribed[mode].notification) {
        $rootScope.$broadcast('grid-toolbar:liveDataNotificationsChanged');
      }
      return;
    }
    subscribed[mode] = {
      data: data,
      loadedData: {} //currently loaded data (so the one filtered by charts etc.)
    };
    subscribed[mode].loadedData[gridId] = data;
    callForNotification(mode, true);
  }
  function unsubscribeGrid(gridId) {
    var mode = gridIdToMode[gridId];
    if (_.get(subscribed, [mode, 'loadedData'])) {
      subscribed[mode].loadedData[gridId] = undefined;
    }
  }
  function isMarketChildGrid(mode, gridId) {
    return mode === 'market' && gridId !== 'market-demand-analysis';
  }
  function unsubscribe(gridId) {
    var mode = gridIdToMode[gridId];
    if (isMarketChildGrid(mode, gridId)) {
      unsubscribeGrid(gridId);
      return;
    }
    unsubscribeByMode(mode);
  }
  function unsubscribeByMode(mode) {
    $rootScope.$broadcast('grid-toolbar:liveDataNotificationsUnsubscribed');
    subscribed[mode] = undefined;
  }
  function resetNotificationForToolbar() {
    return {
      l2Count: 0,
      l3Count: 0,
      total: 0
    };
  }
  function prepareNotificationForToolbar(gridId, loadedData) {
    var mode = gridIdToMode[gridId];
    if (mode === 'flight') {
      var notificationData = flightLiveDataService.prepareNotificationForFlightToolbar(gridId, subscribed[mode], loadedData);
      return {
        l2Count: notificationData.l2.length,
        l3Count: notificationData.l3.length,
        total: notificationData.l2.length + notificationData.l3.length
      };
    } else if (mode === 'market') {
      return marketLiveDataService.prepareNotificationForMarketToolbar(gridId, subscribed[mode], loadedData);
    }
  }
  return {
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    unsubscribeGrid: unsubscribeGrid,
    unsubscribeByMode: unsubscribeByMode,
    prepareNotificationForToolbar: prepareNotificationForToolbar,
    resetNotificationForToolbar: resetNotificationForToolbar
  };
};
LiveDataService.$inject = ['$timeout', '$rootScope', 'FlightLiveDataService', 'MarketLiveDataService', 'ScenarioService', 'HepService'];
module.exports = LiveDataService;